module.exports = __webpack_public_path__ + "img/img02.92028184.png";